import styled from "@emotion/styled";
import { FaMagento } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.div`
  background-color: #101522;
  padding: 20px 0 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FooterContent = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  gap: 30px;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  
  @media screen and (max-width: 820px) {
    width: 100%;
    justify-content: center;
  }
`;

export const FooterCenter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  
  @media screen and (max-width: 820px) {
    width: 100%;
  }
`;

export const FooterRight = styled.div`
  display: flex;
  gap: 20px;
  flex-shrink: 0;
  
  @media screen and (max-width: 820px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const FooterText = styled.div`
  color: #ccc;
  font-size: 13px;
  line-height: 1.4;
  
  @media screen and (max-width: 820px) {
    font-size: 12px;
  }
`;

export const FooterLink = styled(Link)`
  color: #61dafb;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;

  &:hover {
    color: #0467fb;
    transition: 0.3s ease-out;
  }
  
  @media screen and (max-width: 820px) {
    font-size: 13px;
  }
`;

export const FooterBottom = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 15px 20px 5px 20px;
  border-top: 1px solid #2a2e3e;
  margin-top: 15px;
  text-align: center;
`;

export const SocialLogo = styled(Link)`
  color: #fff;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;

  &:hover {
    color: #0467fb;
    transition: 0.3s ease-out;
  }

   img {
        width: 120px;
        height: 120px;
        object-fit: contain;
    }
`;

export const WebsiteRights = styled.small`
  color: #999;
  font-size: 12px;
`;

// Legacy exports for backwards compatibility (if needed elsewhere)
export const FooterSubscription = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 24px;
  padding: 24px;
  color: #fff;
`;

export const FooterSubHeading = styled.p`
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande',
    'Lucida Sans', Arial, sans-serif;
  margin-bottom: 24px;
  font-size: 24px;
`;

export const FooterSubText = styled.p`
  margin-bottom: 24px;
  font-size: 20px;
`;

export const Form = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    width: 80%;
  }
`;

export const FormInput = styled.input`
  padding: 10px 20px;
  border-radius: 2px;
  margin-right: 10px;
  outline: none;
  border: none;
  font-size: 16px;
  border: 1px solid #fff;

  &::placeholder {
    color: #242424;
  }

  @media screen and (max-width: 820px) {
    width: 100%;
    margin: 0 0 16px 0;
  }
`;

export const FooterLinksContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 820px) {
    padding-top: 32px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px;
  text-align: left;
  width: 500px;
  box-sizing: border-box;
  color: #fff;

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

export const FooterLinkTitle = styled.h2`
  margin-bottom: 16px;
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  max-width: 1000px;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const SocialIcon = styled(FaMagento)`
  margin-right: 10px;
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 240px;
`;

export const SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;

  &:hover {
    color: #0467fb;
    transition: 0.3s ease-out;
  }
`;

export const Button = styled.button`
  border-radius: 4px;
  background: ${({ primary }) => (primary ? '#4B59F7' : '#0467FB')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '12px 64px' : '10px 20px')};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  &:hover {
    transition: all 0.3s ease-out;
    background: #fff;
    background-color: ${({ primary }) => (primary ? '#0467FB' : '#4B59F7')};
  }
  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;